<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <h3 class="pull-left">{{ moduloTitulo }}</h3>
      </div>
    </div>
    <!-- {{ checkbox }} -->
    <section class="content">
      <div class="col-md-12">
        <div class="container-fluid">
          <div class="row" width="100%" style="clear: both">
            <div class="col-md-12 overlay">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">
                    <small
                      v-html="
                        table != 'table' ? '<i class=\'fa fa-sort\'></i>  ' : ''
                      "
                    ></small>
                    {{ pantallaTitulo }}
                  </h3>

                  <div class="card-tools">
                    <ul class="nav nav-pills ml-auto">
                      <li
                        class="nav-item"
                        style="padding-right: 5px"
                        v-if="
                          typeof draggable != 'undefined' && draggable === true
                        "
                      >
                        <button
                          type="button"
                          class="btn btn-xs btn-primary"
                          @click="sortable"
                        >
                          <i class="fa fa-sort"></i>
                        </button>
                      </li>
                      <li
                        class="nav-item"
                        v-for="(button, keybu) in buttonsPage"
                        v-bind:key="keybu"
                        style="padding-right: 5px"
                      >

                        <a v-if="button.external" :href="button.external">
                          <button
                            type="button"
                            :class="button.class"
                            v-html="button.text"
                          ></button>
                        </a>
                        <button
                          v-else-if="
                            button.submitCheckbox &&
                            (!button.permisos ||
                              (typeof permisos[button.permisos.opcion] !==
                                'undefined' &&
                                typeof permisos[button.permisos.opcion][
                                  button.permisos.tarea
                                ] !== 'undefined'))
                          "
                          type="button"
                          :class="button.class"
                          v-on:click.prevent="submitCheckbox(button)"
                          v-html="button.text"
                        ></button>
                        <button
                          v-else-if="
                            button.path
                          "
                          type="button"
                          :class="button.class"
                          v-on:click.prevent="RedirectButtonPath(button.route)"
                          v-html="button.text"
                        ></button>
                        <button
                          v-else-if="
                            !button.permisos ||
                            (typeof permisos[button.permisos.tarea] !==
                              'undefined' &&
                              typeof permisos[button.permisos.opcion][
                                button.permisos.tarea
                              ] !== 'undefined')
                          "
                          type="button"
                          :class="button.class"
                          v-on:click.prevent="RedirectButton(button.route)"
                          v-html="button.text"
                        ></button>
                      </li>
                      <li class="nav-item">
                        <button
                          type="button"
                          class="btn btn-xs btn-success pull-right"
                          v-on:click.prevent="getData('excel', false, 'blob')"
                        >
                          <i class="fa fa-file-excel"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-body list">
                  <div class="table-responsive" style="margin-bottom: 0px">
                    <div class="col-sm-12 d-table" style="height: 40px">
                      <div
                        class="col-sm-3 d-table-cell align-middle ocultar_movil"
                      >
                        <small
                          >{{ this.$root.trans("Resultado(s)") }}:
                          {{ pagination.total }} /
                          {{ this.$root.trans("Paginas") }}:
                          {{ pagination.last_page }}</small
                        >
                      </div>
                      <div class="col-sm-6 d-table-cell">
                        <nav class="">
                          <ul
                            class="pagination justify-content-center"
                            style="margin-top: 3px; margin-bottom: 2px"
                          >
                            <li
                              v-if="pagination.current_page == 1"
                              class="page-item disabled"
                            >
                              <a class="page-link" href="#" @click.prevent=""
                                >Atras</a
                              >
                            </li>
                            <li v-else>
                              <a
                                href="#"
                                class="page-link"
                                @click.prevent="
                                  changePage(pagination.current_page - 1)
                                "
                              >
                                <span>Atras</span>
                              </a>
                            </li>
                            <li
                              class="page-item"
                              v-for="page in pagesNumber"
                              v-bind:key="page"
                              v-bind:class="[
                                page == pagination.current_page
                                  ? 'page-item disabled'
                                  : 'page-item d-none d-sm-none d-md-block',
                              ]"
                            >
                              <a
                                href="#"
                                class="page-link"
                                @click.prevent="changePage(page)"
                              >
                                {{ page }}
                              </a>
                            </li>
                            <li
                              v-if="
                                pagination.current_page == pagination.last_page
                              "
                              class="page-item disabled"
                            >
                              <a href="#" class="page-link" @click.prevent="">
                                <span>Siguiente</span>
                              </a>
                            </li>
                            <li v-else>
                              <a
                                href="#"
                                class="page-link"
                                @click.prevent="
                                  changePage(pagination.current_page + 1)
                                "
                              >
                                <span>Siguiente</span>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                      <div
                        class="col-sm-3 d-table-cell align-middle justify-content-right ocultar_movil"
                      >
                        <small>
                          {{ this.$root.trans("Registros por pagina") }}:
                          <select
                            name=""
                            id=""
                            v-model="pagination.per_page"
                            @change.prevent="
                              changePage(pagination.current_page)
                            "
                          >
                            <option>10</option>
                            <option>20</option>
                            <option>50</option>
                            <option>100</option>
                            <option>200</option>
                            <option value="10000">Todos</option>
                          </select>
                        </small>
                      </div>
                    </div>
                  </div>
                  <form
                    name="listado"
                    id="listado"
                    v-on:submit="getDataEvent"
                    action=""
                    method="get"
                    autocomplete="nope"
                  >
                    <div class="">
                      <table class="table table-hover" style="height: 200px">
                        <thead
                          class="thead-light sticky"
                          style="position: sticky; top: 0"
                        >
                          <tr>
                            <th
                              class="header"
                              scope="col"
                              v-for="(
                                inputBusqueda, NameKey
                              ) in busquedaTraduccion"
                              v-bind:key="NameKey"
                              :style="'width:' + busquedaMedidas[NameKey]"
                            >
                              <!-- {{(typeof busquedaCampos[NameKey] != 'undefined')?busquedaCampos[NameKey].type:'nada' }} -->
                              <div
                                v-if="
                                  typeof busquedaCampos != 'undefined' &&
                                  typeof busquedaCampos[NameKey] !=
                                    'undefined' &&
                                  busquedaCampos[NameKey].type == 'select'
                                "
                              >
                                <v-select
                                  v-model="busquedaAvanzada[NameKey]"
                                  @search="
                                    (search, loading) =>
                                      onSearch(
                                        search,
                                        loading,
                                        busquedaCampos[NameKey]
                                      )
                                  "
                                  :create-option="
                                    (value) => ({ label: value, code: value })
                                  "
                                  :reduce="(value) => value.code"
                                  :options="busquedaCampos[NameKey].options"
                                  :item-text="NameKey"
                                  @input="getDataEvent()"
                                  :placeholder="inputBusqueda"
                                >
                                </v-select>
                                <input
                                  type="hidden"
                                  :name="'filtro[' + NameKey + ']'"
                                  v-model="busquedaAvanzada[NameKey]"
                                />
                              </div>

                              <input
                                v-else-if="
                                  typeof busquedaCampos != 'undefined' &&
                                  typeof busquedaCampos[NameKey] !=
                                    'undefined' &&
                                  (busquedaCampos[NameKey].type == 'readonly' ||
                                    busquedaCampos[NameKey].type === 'checkbox')
                                "
                                type="readonly"
                                readonly="readonly"
                                class="form-control"
                                :placeholder="inputBusqueda"
                              />
                              <input
                                v-else-if="
                                  typeof busquedaCampos != 'undefined' &&
                                  typeof busquedaCampos[NameKey] !=
                                    'undefined' &&
                                  busquedaCampos[NameKey].type == 'date'
                                "
                                :type="type[NameKey] ? type[NameKey] : 'text'"
                                class="form-control"
                                :placeholder="inputBusqueda"
                                onfocus="(this.type='date')"
                                onblur="(this.type='text')"
                                v-model="busquedaAvanzada[NameKey]"
                                :name="'filtro[' + NameKey + ']'"
                                @change="busquedaInput"


                              />
                              <input
                                v-else-if="
                                  typeof busquedaCampos != 'undefined' &&
                                  typeof busquedaCampos[NameKey] !=
                                    'undefined' &&
                                  busquedaCampos[NameKey].type == 'time'
                                "
                                type="time"
                                class="form-control"
                                :placeholder="inputBusqueda"
                              />

                              <input
                                v-else
                                type="text"
                                autocomplete="nope"
                                class="form-control"
                                v-debounce:500="busquedaInput"
                                :name="'filtro[' + NameKey + ']'"
                                v-model="busquedaAvanzada[NameKey]"
                                :placeholder="inputBusqueda"
                              />
                            </th>
                            <th
                              v-if="opciones.length"
                              class="text-center align-middle"
                            >
                              {{ this.$root.trans("Opciones") }}
                            </th>
                          </tr>
                        </thead>

                        <tbody v-if="table == 'table'" class="table-body">
                          <tr v-for="item in items" v-bind:key="item.id">
                            <td
                              v-for="(
                                inputBusqueda, NameKey
                              ) in busquedaTraduccion"
                              v-bind:key="NameKey"
                            >
                              <span
                                v-if="
                                  booleans &&
                                  typeof booleans[NameKey] != 'undefined'
                                "
                                >{{ item[NameKey] ? "Si" : "No" }}</span
                              >
                              <span
                                v-else-if="
                                  busquedaCampos[NameKey] &&
                                  busquedaCampos[NameKey].type === 'checkbox'
                                "
                              >
                                <center>
                                  <input
                                    type="checkbox"
                                    :class="'checkbox ' + NameKey + '-check'"
                                    :name="NameKey + '[]'"
                                    :value="item[NameKey]"
                                  />
                                </center>
                              </span>

                              <span v-else v-html="item[NameKey]"></span>
                            </td>

                            <td class="text-center" v-if="opciones.length">
                              <div class="btn-group">
                                <span
                                  v-for="(opcion, KeyName) in opciones"
                                  v-bind:key="KeyName"
                                >
                                  <span
                                    v-if="
                                      typeof opcion.ruta_manual !== 'undefined'
                                    "
                                  >
                                    <router-link
                                      :to="
                                        opcion.routerName + item[opcion.param]
                                      "
                                      exact-path
                                      ><button
                                        type="button"
                                        :class="opcion.class"
                                      >
                                        <i :class="opcion.icon"></i></button
                                    ></router-link>
                                  </span>

                                  <span
                                    v-else-if="
                                      typeof opcion.externo !== 'undefined'
                                    "
                                  >
                                    <a
                                      :href="
                                        opcion.routerName + item[opcion.param]
                                      "
                                      ><button
                                        type="button"
                                        :class="opcion.class"
                                      >
                                        <i :class="opcion.icon"></i></button
                                    ></a>
                                  </span>

                                  <span
                                    v-else-if="
                                      typeof opcion.solicitud !== 'undefined'
                                    "
                                  >
                                    <button
                                      type="button"
                                      :class="opcion.class"
                                      v-on:click.prevent="
                                        enviarSolicitud(
                                          item[opcion.param],
                                          opcion.routerName,
                                          opcion.mensaje
                                        )
                                      "
                                    >
                                      <i :class="opcion.icon"></i>
                                    </button>
                                  </span>

                                  <span v-else-if="opcion.eliminar == false">
                                    <router-link
                                      :to="{
                                        name: opcion.routerName,
                                        params: { id: item[opcion.param] },
                                      }"
                                      style="padding: 0px 2px"
                                    >
                                      <button
                                        type="button"
                                        :class="opcion.class"
                                      >
                                        <i :class="opcion.icon"></i>
                                      </button>
                                    </router-link>
                                  </span>

                                  <span v-else style="padding: 0px 2px">
                                    <button
                                      type="button"
                                      :class="opcion.class"
                                      v-on:click.prevent="
                                        deleteRegister(
                                          item[opcion.param],
                                          opcion.routerName
                                        )
                                      "
                                    >
                                      <i :class="opcion.icon"></i>
                                    </button>
                                  </span>
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <draggable
                          v-model="items"
                          v-if="table == 'draggable'"
                          class="table-body"
                          tag="tbody"
                          @change="changeOrder"
                        >
                          <tr v-for="item in items" v-bind:key="item.id">
                            <td
                              v-for="(
                                inputBusqueda, NameKey
                              ) in busquedaTraduccion"
                              v-bind:key="NameKey"
                            >
                              <span
                                v-if="
                                  booleans &&
                                  typeof booleans[NameKey] != 'undefined'
                                "
                                >{{ item[NameKey] ? "Si" : "No" }}</span
                              >
                              <span v-else>{{ item[NameKey] }}</span>
                            </td>

                            <td class="text-center" v-if="opciones.length">
                              <div class="btn-group">
                                <span
                                  v-for="(opcion, KeyName) in opciones"
                                  v-bind:key="KeyName"
                                >
                                  <span
                                    v-if="
                                      typeof opcion.ruta_manual !== 'undefined'
                                    "
                                  >
                                    <router-link
                                      :to="
                                        opcion.routerName + item[opcion.param]
                                      "
                                      exact-path
                                      ><button
                                        type="button"
                                        :class="opcion.class"
                                      >
                                        <i :class="opcion.icon"></i></button
                                    ></router-link>
                                  </span>

                                  <span
                                    v-else-if="
                                      typeof opcion.externo !== 'undefined'
                                    "
                                  >
                                    <a
                                      :href="
                                        opcion.routerName + item[opcion.param]
                                      "
                                      ><button
                                        type="button"
                                        :class="opcion.class"
                                      >
                                        <i :class="opcion.icon"></i></button
                                    ></a>
                                  </span>

                                  <span
                                    v-else-if="
                                      typeof opcion.solicitud !== 'undefined'
                                    "
                                  >
                                    <button
                                      type="button"
                                      :class="opcion.class"
                                      v-on:click.prevent="
                                        enviarSolicitud(
                                          item[opcion.param],
                                          opcion.routerName,
                                          opcion.mensaje
                                        )
                                      "
                                    >
                                      <i :class="opcion.icon"></i>
                                    </button>
                                  </span>

                                  <span v-else-if="opcion.eliminar == false">
                                    <router-link
                                      :to="{
                                        name: opcion.routerName,
                                        params: { id: item[opcion.param] },
                                      }"
                                      style="padding: 0px 2px"
                                    >
                                      <button
                                        type="button"
                                        :class="opcion.class"
                                      >
                                        <i :class="opcion.icon"></i>
                                      </button>
                                    </router-link>
                                  </span>

                                  <span v-else style="padding: 0px 2px">
                                    <button
                                      type="button"
                                      :class="opcion.class"
                                      v-on:click.prevent="
                                        deleteRegister(
                                          item[opcion.param],
                                          opcion.routerName
                                        )
                                      "
                                    >
                                      <i :class="opcion.icon"></i>
                                    </button>
                                  </span>
                                </span>
                              </div>
                            </td>
                          </tr>
                        </draggable>
                      </table>
                    </div>
                  </form>
                </div>
                <!-- <pre>{{items}}</pre> -->
                <div class="card-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
td,
th {
  font-size: 10px !important;
}
span {
  font-size: 12px !important;
}
input.form-control {
  font-size: 13px;
}
.header {
  position: sticky;
  top: 0;
}
body {
  height: 800px;
}
</style>
<script type="text/javascript">
import draggable from "vuedraggable";

export default {
  name: "tableOrdered",
  display: "Table",
  order: 8,
  components: {
    draggable,
  },
  props: [
    "watch",
    "pivots",
    "busqueda",
    "busquedaTraduccion",
    "booleans",
    "busquedaMedidas",
    "opciones",
    "moduloTitulo",
    "pantallaTitulo",
    "rutaConsulta",
    "buttonsPage",
    "busquedaCampos",
    "draggable",
    "permisos",
  ],
  data() {
    return {
      items: [{}],
      checkbox: [],
      type: {},
      offset: 10,
      table: "table",
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0,
      },
      busquedaAvanzada: {},
      dragging: false,
    };
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page;
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return [];
      }

      var from = this.pagination.current_page - this.offset;

      if (from < 1) {
        from = 1;
      }

      var to = from + this.offset * 2;
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }

      if (to > this.pagination.current_page + 3) {
        if (this.pagination.current_page < 4) {
          to = 7;
        } else {
          to = this.pagination.current_page + 3;
        }
      }

      if (from < this.pagination.current_page - 3) {
        from = this.pagination.current_page - 3;
      }

      var pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }

      return pagesArray;
    },
  },
  methods: {
    submitCheckbox(button) {
      const data = [
        ...document.querySelectorAll("." + button.name + "-check:checked"),
      ].map((e) => e.value);

      if (button.singleCheckbox && data.length > 1) {
        alert("Debe seleccionar una sola ficha");
        return;
      }
      let params = new URLSearchParams({ fichas: data });
      let href = button.route + "?" + params;

      if (button.externalCheck) {
        window.location.href = href;
      }else{
          this.$router.push(href);
      }


      //   this.$router.push({ name: button.route, params: { fichas: data } });
    },
    sortable() {
      if (this.table == "table") {
        this.table = "draggable";
      } else {
        this.table = "table";
      }
    },
    changeOrder() {
      this.$root
        .Consulta(
          this.rutaConsulta + "/sortable",
          this.items,
          "post",
          false,
          false,
          ".overlay",
          "initial",
          false,
          true,
          false
        )
        .then((response) => {});
    },
    busquedaInput() {
      this.getData(1);
    },
    RedirectButton: function (route) {
      this.$router.push({ name: route });
    },
    RedirectButtonPath: function (route) {
      this.$router.push({ path: route });
    },
    onSearch(search, loading, option) {
      if (
        typeof option.options[0] == "undefined" ||
        typeof option.options[0].search == "undefined" ||
        option.options[0].search != false
      ) {
        if (typeof option.ajax != "undefined" && search.length) {
          loading(true);
          var url = option.ajax.url + "?q=" + escape(search);
          this.search(loading, search, option, url, this);
        }
      }
    },
    search: _.debounce((loading, search, option, url, n) => {
      var data = {
        label: option.ajax.label,
        code: option.ajax.code,
        filtro: {},
      };

      data["filtro"][option.ajax.filter] = search;

      n.$root
        .Consulta(url, data, "post", false, false, false, "", false)
        .then((response) => {
          var newValues = [];

          option.options = response.concat(newValues);
          loading(false);
        });
    }, 350),

    submitDb: _.debounce((n) => {
      n.getData();
    }, 150),

    getDataEvent: function (e) {
      this.submitDb(this);
    },

    getData(page = 1, data = false, tipo = "json") {
      $(".checkbox").prop("checked", false);

      if (!data) {
        data = new FormData($("form#listado")[0]);
        data.append("per_page", this.pagination.per_page);
        data.append("pivots", JSON.stringify(this.pivots));
        data.append("preRequest", JSON.stringify(this.$route.query));
      }

      this.$root
        .Consulta(
          this.rutaConsulta + "?page=" + page,
          data,
          "post",
          false,
          false,
          ".overlay",
          "initial",
          false,
          true,
          false,
          tipo
        )
        .then((response) => {
          if (tipo != "json") {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "file.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
            return;
          }

          if (response != false) {
            this.items = response.result;
            this.pagination = response.pagination;
            this.$store.commit("busqueda", {
              busqueda: this.busquedaAvanzada,
              page: page,
              data: data,
              listado: this.$route.name,
            });
          }
        });
    },
    enviarSolicitud(id, ruta, mensaje = false) {
      this.$root
        .Consulta(
          ruta + id,
          {},
          "post",
          true,
          true,
          ".table-body",
          "initial",
          true,
          false,
          mensaje
        )
        .then((response) => {
          if (response != false) {
            if (
              this.pagination.current_page == this.pagination.last_page &&
              this.items.length == 1
            ) {
              this.getData(this.pagination.current_page - 1);
            } else {
              this.getData(this.pagination.current_page);
            }
          }
        });
    },
    changePage: function (page) {
      this.pagination.current_page = page;
      this.getData(page);
    },
    deleteRegister(id, ruta) {
      this.$root
        .Consulta(
          ruta + id,
          {},
          "post",
          true,
          true,
          ".table-body",
          "initial",
          true,
          false
        )
        .then((response) => {
          if (response != false) {
            if (
              this.pagination.current_page == this.pagination.last_page &&
              this.items.length == 1
            ) {
              this.getData(this.pagination.current_page - 1);
            } else {
              this.getData(this.pagination.current_page);
            }
          }
        });
    },
  },
  mounted() {
    //  $('table').sortable({ items: 'tbody' });
    if (typeof this.$store.state.busqueda.page != "undefined") {
      if (this.$route.name == this.$store.state.busqueda.listado) {
        var page = this.$store.state.busqueda.page;
        this.busquedaAvanzada = this.$store.state.busqueda.busqueda;
        this.getData(page);
      } else {
        if (this.rutaConsulta !== false) {
          this.getData();
        }
      }
    } else if (this.rutaConsulta !== false) {
      this.getData();
    }
  },
  created() {
    //hacemos esto para evitar sobre escribir el componente padre generando errores
    this.busquedaAvanzada = this.busqueda;
  },
  watch: {
    rutaConsulta: function (val) {
      this.getData();
    },
    busqueda: function (val) {
      this.busquedaAvanzada = this.busqueda;
    },
    busquedaAvanzada: {
      handler(newValue, oldValue) {
        //    this.submitDb();
        // this.$root.Consulta(this.rutaConsulta+'?page='+1,this.busquedaAvanzada,'post',false,false,'.overlay','initial',false,true,false).then(response =>{
        // if(response != false){
        // 	this.items = response.result;
        //     this.pagination = response.pagination;
        //     this.$store.commit('busqueda',{
        //         busqueda:this.busquedaAvanzada,
        //         page:0,
        //         data:this.busquedaAvanzada,
        //         listado:this.$route.name
        //     });
        // }
        // });
      },
      deep: true,
    },
  },
};
</script>
